import jet from "@randajan/jet-core";
import { info } from "@randajan/simple-app/fe";
import createFetch, { ApiError } from "@randajan/api-kit/client";
import { bifrost } from "./bifrost";

import createVault from "@randajan/vault-kit";

function getFingerprint() {
    const cores = navigator.hardwareConcurrency;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return btoa(`${cores}:${timezone}`);
}

const fetchLinkRepo = createFetch({
    url:"/link/repo/",
    cache:"no-cache",
    resultOnly:true,
    throwError:true,
    onError:({error})=>console.error(String(error)),
    trait:(opt)=>{
        console.log(opt);
    }
});

const linkVault = createVault({
    hasMany:true,
    remote:{
        init:(set, forget)=>{
            bifrost.rx("linkEcho", (socket, { pid, content })=>{
                set(content, pid);
            });
        },
        pull:()=>{

        }
    }
});

export const linkVaultCreate = async ({version, action, args})=>{
    const fp = getFingerprint();
    return bifrost.tx("linkOpen", {fp, body:{action, version, args}});
}


let _link;
const findLink = async ()=>{
    if (_link) { return _link; }

    await Promise.all(info.link.ports.map(async port=>{
        try {
            const url = `http://localhost:${port}/`;
            const resp = await fetch(url+"ping");
            if (resp.status !== 204) { return; }
            
            const fetchLink = createFetch({
                url,
                cache:"no-cache",
                resultOnly:true,
                throwError:true,
                onError:({error})=>console.error(String(error))
            });
            const { version } = await fetchLink("about");
            fetchLink.version = version;
            _link = fetchLink;

        } catch {}
    }));

    if (_link) { return _link; }

    throw new ApiError(9, "Can't find itcanLink service");
}

export const getActualVersion = async ()=>{
    return fetchLinkRepo.get("stable");
}

export const linkAbout = async _=>{
    const fetchLink = await findLink();
    return fetchLink.get("about");
}

export const linkFetch = async (action, args, timeout=30000)=>{
    const fetchLink = await findLink();
    const { version } = fetchLink;

    const res = await linkVaultCreate({version, action, args}); //instruction
    const { pid, content, instructions } = res;

    await fetchLink.post("api", { code:2, body:{instructions} });

    return new Promise((res, rej)=>{
        const int = setTimeout(_=>{
            rem();
            rej(new ApiError(1, "Timeout"));
        }, timeout);

        const rem = linkVault.once(({data:content}, _pid)=>{
            if (_pid !== pid) { return; }
            if (content.state !== "done") { console.log(content); return; }
            clearTimeout(int);
            res({ pid, content });
        });

    });

}


